import { React, Fragment, useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import { getLedgerByID, searchMemberLedger } from "../../../../api/apiServices";
import toast, { Toaster } from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import "./LedgerUpdate.css";

const UpdateLedger = () => {
  const [updateModal, setUpdateModal] = useState(false);
  const [search, setSearch] = useState("false");
  const [pf_number, setPfNumber] = useState("");
  const [mobile_number, setMobileNumber] = useState("");
  const [member_ledger, setMemberLedger] = useState([]);

  const [updateData, setUpdateData] = useState({
    id: "",
    pf_number: "",
    mobile_number: "",
    year: "",
    opening_balance: "",
    expected_total_amount:"",
    total_amount_paid:"",
    closing_balance: "",
    closing_balance:"" 

  });

  const handleSearch = async (e) => {
    e.preventDefault();
    const searchData = {
      pf_number: pf_number,
      mobile_number: mobile_number,
    };
    searchMutation.mutate(searchData);
  };

  const searchMutation = useMutation(searchMemberLedger, {
    onSuccess: async (res) => {
      if (res.status) {
        if (res.member.length > 0) {
          setMemberLedger(res.member);
          setSearch(true);
        } else {
          toast.info(res.message, {
            duration: 5000,
            className: "toast-message",
          });
          setSearch(false);
          setPfNumber("");
          setMobileNumber("");
        }
      } else {
        toast.error(res.message, {
          duration: 5000,
          className: "toast-message",
        });
        return false;
      }
    },
    onError: async (err) => {
      toast.error(err, {
        duration: 5000,
        className: "toast-message",
      });
    },
  });

  console.log(mobile_number)
  const handleOnChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setUpdateData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleOnBlur = (e) => {
    const value = e.target.value;

    const totalStock = updateData.stock;
    if (value > totalStock) {
      alert(
        "Order placed is greater than available stocks. Check and try again !"
      );
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {};
  const handleUpdate = (e) => {};

  const handleEdit = (id) => {
     const yearLedger = member_ledger?.find((element) => element.id === id);
     if(yearLedger){
        console.log(yearLedger)
        setUpdateData({
          id: yearLedger.id,
          pf_number: yearLedger.pf_number,
          mobile_number: yearLedger.mobile_number,
          year: yearLedger.year,
          opening_balance: yearLedger.opening_balance,
          expected_total_amount: yearLedger.expected_total_amount,
          total_amount_paid: yearLedger.total_amount_paid,
          closing_balance: yearLedger.closing_balance,
        });
     }
      setUpdateModal(true);
      
    };
    const handleCancel = () => {
        setSearch(false);
        setUpdateModal(false);
  };
  // Return the JSX by building some rows

  let searchContent = (
    <form onSubmit={handleSearch}>
      <div className="form-group row">
        <div className="col-sm-5">
          <input
            className="form-control"
            type="text"
            placeholder="PF Number"
            style={{ textTransform: "uppercase" }}
            onChange={(e) => setPfNumber(e.target.value)}
            value={updateData.pf_number}
          />
        </div>
        <div className="col-sm-5">
          <PhoneInput
            id="mobile_number"
            inputStyle={{
              paddingTop: 16,
              paddingRight: 14,
              paddingBottom: 15,
              paddingLeft: 58,
              fontSize: 16,
              width: "100%",
              zIndex: 1,
              height: 40,
              backgroundColor: "#F3F6F9",
            }}
            countryCodeEditable={false}
            enableClickOutside={false}
            country={"gh"}
            enableSearch={true}
            value={updateData.mobile_number}
            name="mobile_number"
            inputProps={{
              name: "mobile_number",
              required: true,
              autoFocus: true,
            }}
            onChange={(e)=>setMobileNumber(e)}
          />
        </div>
        <div className="col-sm-2">
          <button type="submit" className="btn btn-success btn-block">
            {" "}
            <i className="fa fa-search"></i> Search Member
          </button>
        </div>
      </div>
    </form>
  );

  let content;

  content = (
    <div className="table-responsive lg">
      <table className="table table-borderless table-striped">
        <thead className="align">
          <tr>
            <th scope="col" style={{ whiteSpace: "nowrap" }}>
              PF Number
            </th>
            <th scope="col" style={{ whiteSpace: "nowrap" }}>
              Mobile Number
            </th>
            <th scope="col" style={{ whiteSpace: "nowrap" }}>
              Full Name
            </th>
            <th scope="col" style={{ textAlign: "center" }}>
              Year
            </th>
            <th
              scope="col"
              style={{ whiteSpace: "normal", textAlign: "center" }}
            >
              Opening Balance
            </th>
            <th
              scope="col"
              style={{ whiteSpace: "normal", textAlign: "center" }}
            >
              Expected Amount
            </th>
            <th
              scope="col"
              style={{ whiteSpace: "normal", textAlign: "center" }}
            >
              Amount Paid
            </th>
            <th
              scope="col"
              style={{ whiteSpace: "normal", textAlign: "center" }}
            >
              Closing Balance
            </th>
            <th scope="col" style={{ textAlign: "center" }}>
              ACTION
            </th>
          </tr>
        </thead>
        <tbody>
          {member_ledger?.map((ledger, index) => (
            <tr key={index}>
              <td style={{ whiteSpace: "nowrap" }}>{ledger?.pf_number}</td>
              <td style={{ whiteSpace: "nowrap" }}>{ledger?.mobile_number}</td>
              <td style={{ whiteSpace: "nowrap" }}>
                {ledger?.members?.first_name} {ledger?.members?.middle_name}{" "}
                {ledger?.members?.last_name}
              </td>
              <td style={{ whiteSpace: "nowrap" }}>{ledger?.year}</td>
              {ledger?.opening_balance < 0 ? (
                <td style={{ textAlign: "right" }}>
                  (
                  {(ledger?.opening_balance * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })}
                  )
                </td>
              ) : (
                <td style={{ textAlign: "right" }}>
                  {ledger?.opening_balance.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })}
                </td>
              )}
              {ledger?.expected_total_amount < 0 ? (
                <td
                  style={{
                    whiteSpace: "nowrap",
                    textAlign: "right",
                  }}
                >
                  (
                  {(ledger?.expected_total_amount * -1).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                    }
                  )}
                  )
                </td>
              ) : (
                <td
                  style={{
                    whiteSpace: "nowrap",
                    textAlign: "right",
                  }}
                >
                  {ledger?.expected_total_amount.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })}
                </td>
              )}
              <td style={{ textAlign: "right" }}>
                {ledger?.total_amount_paid.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                })}
              </td>
              {ledger?.closing_balance < 0 ? (
                <td style={{ textAlign: "right" }}>
                  (
                  {(ledger?.closing_balance * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })}
                  )
                </td>
              ) : (
                <td style={{ textAlign: "right" }}>
                  {ledger?.closing_balance.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })}
                </td>
              )}
              <td
                style={{
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                <div style={{ display: "inline-block" }}>
                  <button
                    type="button"
                    onClick={() => handleEdit(ledger.id)}
                    className="btn btn-success small"
                  >
                    {" "}
                    <i className="fa fa-eye"></i> update
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="col-sm-2">
        <button
          type="button"
          onClick={handleCancel}
          className="btn btn-danger btn-block"
        >
          {" "}
          <i className="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  );

  return (
    <>
      <section className="content-header">
        <Toaster toastOptions={{ position: "top-center" }} />
        <h1>Member Ledger Update</h1>
      </section>
      <section className="content">
        <div className="box">
          <div className="box-body">
            <div className="panel panel-default panel-br-4">
              <div className="panel-heading">
                <div className="row">
                  <div className="col-sm-12">
                    {/* <h4 className="panel-title">{newItemSection}</h4> */}
                  </div>
                </div>
              </div>
              <div className="panel-body">
                {!search && searchContent}
                {search && content}
              </div>
              <div className="panel-body">
                {updateModal && (
                  <div className="modal-container">
                    <div className="modal-frame">
                      <h1 className="modal-header">Update Year Ledger</h1>
                      <button
                        className="cancel-button"
                        onClick={() => setUpdateModal(false)}
                      >
                        X
                      </button>
                      <form onSubmit={handleSubmit}>
                        <label htmlFor="pf_number">PF Number</label>
                        <input
                          type="text"
                          id="pf_number"
                          name="pf_number"
                          required
                          disabled
                          autoComplete="off"
                          value={updateData.pf_number}
                          onBlur={handleOnBlur}
                          onChange={handleOnChange}
                          className="form-control"
                        />
                        <label htmlFor="mobile_number">Phone Number</label>
                        <input
                          type="text"
                          id="mobile_number"
                          name="mobile_number"
                          required
                          autoComplete="off"
                          value={updateData.mobile_number}
                          disabled
                          onBlur={handleOnBlur}
                          onChange={handleOnChange}
                          className="form-control"
                        />

                        <div className="flex space-x-2">
                          <button className="w-full p-2  bg-green-500 text-white rounded cursor-pointer  hover:bg-green-700">
                            Place Order
                          </button>

                          <button
                            type="button"
                            className="w-full p-2 rounded-md bg-gray-500 text-white  cursor-pointer hover:bg-gray-700"
                            onClick={handleCancel}
                          >
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="box-footer"></div>
        </div>
      </section>
    </>
  );
};

export default UpdateLedger;
